module.exports = __webpack_public_path__ + "img/mortgage-mob-img.af97a84d.webp";